import { AsyncDialog } from '@aipb/dialog';
import { Injectable } from '@angular/core';
import { CopyNibbleDialogDataModel } from './copy-nibble-dialog-data.model';
import { CopyNibbleDialogComponent } from './copy-nibble-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CopyNibbleDialogService extends AsyncDialog<CopyNibbleDialogComponent, CopyNibbleDialogDataModel> {
  async loadComponent() {
    return import('./copy-nibble-dialog.component').then((r) => r.CopyNibbleDialogComponent);
  }
}
